import { Grid } from '@mantine/core';
import * as React from 'react';
import { useMemo } from 'react';
import type { MantineColumn } from '../../../../../../react-commons/components/table/MantineTable';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import { ControlledInputs } from '../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import {
    defaultProjectUserGroupRoleAssignmentResource,
    type ProjectUserGroupRoleAssignmentResource,
    useProjectUserGroupRoleAssignmentActions,
} from '../../../../resource/resources/persistables/user/projectUserGroupRoleAssignmentResource';
import { CrudValidationTable } from '../../../reusable-components/tables/CrudValidationTable';
import { AddOrUpdateProjectUserGroupRoleAssignmentDialog } from './AddOrUpdateProjectUserGroupRoleAssignmentDialog';
import { useProjectUserRoleActions } from '../../../../resource/resources/persistables/user/projectUserRoleResource';

export const ProjectUserGroupRolesTabContent= ({ id, projectUserGroupRoleAssignment, parentId }: {
    id: string | undefined;
    projectUserGroupRoleAssignment: ProjectUserGroupRoleAssignmentResource | undefined;
    parentId: string;
}) => {
    const nestedDialog = useNestedDialogFunction();

    const projectUserRoleActions = useProjectUserRoleActions()

    const roles = projectUserRoleActions.useGetAllResources(parentId);
    const projectUserGroupRoleAssignmentActions = useProjectUserGroupRoleAssignmentActions()

    const updateRoleAssignment = projectUserGroupRoleAssignmentActions.useUpdateResource();

    const openAddOrUpdateProjectUserGroupRoleAssignmentDialog = () => {
        if (roles.data) {
            nestedDialog.showNestedDialog(
                <AddOrUpdateProjectUserGroupRoleAssignmentDialog
                    roles={roles.data}
                    projectUserRoleAssignment={
                        projectUserGroupRoleAssignment ?? {
                            ...defaultProjectUserGroupRoleAssignmentResource,
                            projectUserGroup: id ?? '',
                        }
                    }
                    onClose={nestedDialog.closeNestedDialog}
                    parentId={parentId}
                />,
            );
        }
    };

    const columns = useMemo((): Array<MantineColumn<{ roleNameId: string }>> => {
        return [
            {
                type: 'reference',
                header: 'Role',
                Header: null,
                accessorKey: 'roleNameId',
                Cell: ({ row }) => (
                    <ControlledInputs.String
                        nullable={false}
                        readOnly={true}
                        value={roles.data?.find((value) => value.id === row.original.roleNameId)?.name ?? ''}
                        style={{
                            paddingLeft: 0,
                            width: '100%',
                            borderBottom: 'none',
                        }}
                    />
                ),
            },
        ];
    }, [roles.data]);

    return (
        <Grid>
            <Grid.Col span={12}>
                <CrudValidationTable
                    columns={columns}
                    data={projectUserGroupRoleAssignment?.projectUserRoles.map((roleNameId) => ({ roleNameId }))}
                    label={'User Group Roles Assigned'}
                    onAdd={openAddOrUpdateProjectUserGroupRoleAssignmentDialog}
                    onDelete={(resource) => {
                        if (projectUserGroupRoleAssignment) {
                            const newState = { ...projectUserGroupRoleAssignment };
                            newState.projectUserRoles = newState.projectUserRoles.filter(
                                (value) => value !== resource.roleNameId,
                            );
                            updateRoleAssignment.mutate({
                                resource: newState,
                                id: newState.id,
                            });
                        }
                    }}
                    onEdit={undefined}
                />
            </Grid.Col>
        </Grid>
    );
};


